var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.681,
    height: 91.569,
    viewBox: "0 0 90.681 91.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-edit",
    transform: "translate(-2.407 -2.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M80.863,25.12l5.656,5.657L29.455,87.841,8.062,93.858l-1.426-.772a8.463,8.463,0,0,1-3.38-3.3l-.849-1.442L8.253,66.4,65.2,9.454l5.656,5.657L15.43,70.533,11.7,84.523l13.573-3.817ZM75.054,10.293,85.084,20.5l5.707-5.606L80.761,4.687,75.858,9.5l4.9-4.823A8,8,0,0,0,69.445,4.59S75.062,10.285,75.054,10.293ZM90.8,14.9l-5.7,5.6,5.6,5.717A8,8,0,0,0,90.8,14.9Z",
    fill: "#0071b9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8d476165f3a0b82edef90b8e90da948b.svg";
export { ForwardRef as ReactComponent };